import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from 'components/LoadingSpinner'
import { toast } from 'react-toastify'
import FormModal from '../../../../shared/components/FormModal'

interface RequestReleaseModalProps {
  show: boolean
  onClose: () => void
  onSubmit: (isAcceptedRelease: boolean) => void
  isSubmitting: boolean
  isError: boolean
}

function RequestReleaseModal({
  show,
  onClose,
  onSubmit,
  isSubmitting,
  isError,
}: Readonly<RequestReleaseModalProps>) {
  const [isAcceptedRelease, setIsAcceptedRelease] = useState(false)

  const { t } = useTranslation()

  const submitForm = () => {
    onSubmit(isAcceptedRelease)
  }

  useEffect(() => {
    if (isError) {
      toast.error('Error occurred when sending request release')
    }
  }, [isError])

  return (
    <FormModal show={show} title={t('declaration.p5.requestRelease', { context: 'title' })} onClose={onClose}>
      <div className="d-flex flex-column align-self-center w-100">
        <p>{t('declaration.p5.requestRelease')}</p>
        <div className="form-check d-flex align-items-center me-3">
          <input
            className="form-check-input"
            type="radio"
            name="isAcceptedRelease"
            id="notAcceptedRelease"
            value="false"
            checked={!isAcceptedRelease}
            onChange={() => {
              setIsAcceptedRelease(false)
            }}
          />
          <label className="form-check-label text-nowrap ps-1" htmlFor="notAcceptedRelease">
            {`${t('common.no')} (0)`}
          </label>
        </div>
        <div className="form-check d-flex align-items-center me-3">
          <input
            className="form-check-input"
            type="radio"
            name="isAcceptedRelease"
            id="yesAcceptedRelease"
            value="true"
            checked={isAcceptedRelease}
            onChange={() => {
              setIsAcceptedRelease(true)
            }}
          />
          <label className="form-check-label text-nowrap ps-1" htmlFor="yesAcceptedRelease">
            {`${t('common.yes')} (1)`}
          </label>
        </div>
      </div>
      <div className="d-flex align-content-end justify-content-end mt-5">
        <button
          type="button"
          className="btn btn-lg btn-primary mx-1 text-black shadow-sm"
          onClick={submitForm}
          disabled={isSubmitting}
        >
          {
            isSubmitting && <LoadingSpinner />
          }
          {
            !isSubmitting && (<span>{t('buttons.submit')}</span>)
          }
        </button>
      </div>
    </FormModal>
  )
}

export default RequestReleaseModal
